<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Gráficos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-card>
    <canvas
      baseChart
      [data]="barChartData"
      [options]="barChartOptions"
      [type]="barChartType"
    ></canvas>
  </ion-card>

  <ion-card>
    <canvas
      baseChart
      [data]="pieChartData"
      [options]="pieChartOptions"
      [type]="pieChartType"
    ></canvas>
  </ion-card>
</ion-content>
